export const property = {
  gamefi: "GameFi",
  "mc_official_verify_unofficial": "Kênh xác thực không chính thức",
  "mc_official_verify_official": "Chính thức ",
  "mc_official_verify_fotter_tip_1": "Nhắc nhở rủi ro để ngăn chặn gian lận trực tuyến/giả mạo điện thoại của nhân viên Biking",
  "mc_official_verify_fotter_tip_2": "Biking chính thức công bố Cảnh báo rủi ro nhằm ngăn chặn gian lận",
  "mc_official_verify_modal_tip_1": "[{query}] mà bạn tìm kiếm là kênh chính thức của Biking Kênh",
  "mc_official_verify_modal_tip_3": "Vui lòng xác minh thông tin và định dạng bạn đã nhập là chính xác:",
  "mc_official_verify_modal_tip_4": "Số di động: xx-xxxxxxxxx",
  "mc_official_verify_modal_type_email": "Email",
  "mc_official_verify_modal_type_domain": "Địa chỉ ",
  "mc_official_verify_modal_type_channel": "Kênh",
  "mc_official_verify_input_placeholder": "Vui lòng nhập chính xác thông tin và định dạng để xác minh",
  "mc_official_verify_head_title": "Kênh xác minh chính thức Biking | Sàn giao dịch Biking",
  "mc_official_verify_head_description": "Kênh xác minh chính thức của sàn giao dịch Biking ",
  "mc_official_verify_title": "Kênh xác minh chính thức",
  "mc_official_verify_discription_new": "Để tránh tổn thất tài sản do hành vi gian lận và lừa đảo trực tuyến, bạn có thể xác minh trên trang này các thông tin như địa chỉ website, địa chỉ Email, số điện thoại và các tài khoản xã hội như Twiitter và Telegram có phải là kênh chứng nhận chính thức của Biking hay không.",
  "mc_official_verify_fotter_tip_3": "Hướng dẫn người dùng Biking: Hướng dẫn đề phòng scam, cẩn thận với các thủ đoạn lừa đảo tinh vi!",
  "mc_unofficial_verify_modal_tip_1": "[{query}]Thông tin mà bạn tìm kiếm không phải kênh chính thức của Biking",
  "mc_official_verify_discription": "Để ngăn chặn các bên lừa đảo mạo danh Biking, trang này giúp xác nhận các kênh chính thức của Biking, bao gồm nhưng không giới hạn ở tài khoản X, Facebook, Telegram, số điện thoại, WeChat, v.v.",
  "mc_official_head_title1": "Xác minh các kênh chính thức, tin tức và ấn phẩm của Biking",
  "mc_official_head_keywords1": "xác minh Biking, tin tức Biking, tài khoản chính thức Biking",
  "mc_official_head_description1": "Đảm bảo tính xác thực của các kênh thông tin Biking. Sử dụng kênh xác minh chính thức để xác thực tính hợp pháp của các kênh truyền thông, tin tức và ấn phẩm liên quan đến Biking.",
  "mc_official_verify_verified_title": "Kênh xác minh chính thức",
  "mc_official_verify_modal_tip_5": "Telegram/X/Facebook/Youtube: @xxxxx (kèm ký tự @)",
  "mc_official_verify_modal_tip_6": "TikTok/Instagram: xxxx (không bao gồm ký tự @)",
  "mc_official_verify_modal_tip_7": "Discord: xxxx#xxxx (không bao gồm ký tự @)",
  "mc_official_verify_modal_tip_8": "LinkedIn/Nhóm Telegram/Medium/Reddit: https://xxxxx (liên kết website)",
  "mc_official_verify_modal_tip_9": "Nếu bạn có thắc mắc về định dạng, vui lòng liên hệ với bộ phận hỗ trợ trực tuyến.",
  "mc_official_verify_modal_tip_10": "*Không tiết lộ thông tin tài khoản và mật khẩu của bạn cho bất kỳ ai.",
  "mc_official_verify_modal_tip_11": "*Đề phòng với những chiêu trò gian lận và thận trọng trong thao tác."
,
tagtip: 'Nếu nền tảng nạp tiền không yêu cầu điền vào phần ý kiến, trường này có thể để trống.',
tagtip1: 'Tag là mã định danh duy nhất được dùng để xác định tài khoản hoặc người dùng cụ thể, đảm bảo rằng tiền được gửi đến đúng người nhận.',
tagtip2: 'Các nền tảng giao dịch hoặc ví khác có thể gọi Thẻ là ID kỹ thuật số, thẻ, bản ghi nhớ, ghi chú, nhận xét, v.v.',
  tag: 'Vui lòng nhập bình luận',
  qbcbcg: 'Vui lòng sao chép cả địa chỉ TON và bình luận để đảm bảo việc nạp tiền thành công.',
  qsrzqje: 'Vui lòng nhập số tiền chính xác',
    "dzcw": "Địa chỉ sai",
  "czqkqrs": "Số xác nhận khối nạp",
  "mc": "Tên",
  "cjsj": "Thời gian tạo",
  "lx": "Loại",
  "sl": "Số lượng",
  "cwjl": "Lịch sử tài chính",

  "ylzh": "Lợi nhuận",
  "ddtx": "Chờ rút",
  "txcg": "Rút thành công",
  "yhcx": "Người dùng hủy",
  "qbcbjl": "Toàn bộ lịch sử nạp",

  "zczl": "Tổng quan tài sản",
  "zjzh": "Tài khoản tiền",
  "mbzh": "Tài khoản mua",
  "xhzh": "Tài khoản tiền mặt",
  "hyzh": "Tài khoản hợp đồng",
  lczh: 'Tài khoản tài chính',
  "gdzh": "Tài khoản theo dõi",
  "giftzh": "Tài khoản quà tặng",
  "bwzh": "Thẻ Coin King",
  "mozh": "Tài khoản mô phỏng",
  "mnhy": "Hợp đồng mô phỏng",
  "sxffy": "Hoàn lại từ hệ thống",
  "kt": "Phát tặng",
  "xtkc": "Trừ từ hệ thống",
  "zcfb": "Phân phối tài sản",
  "zcdt": "Tình hình tài sản",
  "zh": "Tài khoản",
  "zc": "Tài sản",
  "czjl": "Lịch sử nạp",
  "txls": "Lịch sử rút",
  "hzjl": "Lịch sử chuyển khoản",
  "mmjl": "Lịch sử mua bán",
  "cb": "Nạp",
  "tx": "Rút",
  "hz": "Chuyển khoản",
  "mb": "Mua",
  "jy": "Giao dịch",
  "zwsj": "Không có dữ liệu",
  "ckqb": "Xem tất cả",
  
    // table
    "bz": "Loại tiền",
    "qc": "Tên đầy đủ",
    "zhze": "Tổng số tài khoản",
    "syzc": "Số dư tài sản",
    "djzc": "Tài sản bị đóng băng",
    "cz": "Thao tác",
    "sl": "Số lượng",
    "cbdz": "Địa chỉ nạp",
    "sj": "Thời gian",
    "zt": "Trạng thái",
    "ms": "Mô tả",
    "hzfx": "Hướng chuyển khoản",
    "hzse": "Số tiền chuyển khoản",
    "txdz": "Địa chỉ rút",
    "sxf": "Phí giao dịch",
    "ddh": "Mã đơn đặt hàng",
    "zj": "Tổng giá",
    "dj": "Giá đơn vị",
    "jysl": "Số lượng giao dịch",
    "jydx": "Đối tượng giao dịch",
    "zhqy": "Quyền lợi tài khoản",
    "zhqytips": "Quyền lợi tài khoản = Margin có thể sử dụng + Margin lưu trữ",
    "kybzj": "Margin có thể sử dụng",
    "kybzjtips": "Margin có thể sử dụng để mở lệnh và chuyển khoản",
    "cwbzj": "Margin lưu trữ",
    "cwbzjtips": "Margin lưu trữ để duy trì các lệnh hiện tại",
  
    // search
    "srbz": "Vui lòng nhập loại tiền tương ứng",
    "ycxzc": "Ẩn tài sản nhỏ",
    "sy": "Tất cả",
    "qb": "Tất cả",
    "qx": "Tất cả",
    "zhi": "đến",
    "ksrq": "Ngày bắt đầu",
    "jsrq": "Ngày kết thúc",
    "cx": "Tìm kiếm",
    "dc": "Xuất",
    "zjqt": "7 ngày gần đây",
    "zjygy": "1 tháng gần đây",
    "qbsj": "Tất cả thời gian",
    "usdt": "USDT",
    "ddlx": "Loại đơn đặt hàng",
    "gm": "Mua",
    "cs": "Bán",
  
    // recharge
    "czxq": "Chi tiết nạp tiền",
    "usdtcbjl": "Lịch sử nạp {coinName}",
    "cbsl": "Số lượng nạp tiền",
    "cbzt": "Trạng thái nạp tiền",
    "crdbz": "Vui lòng chọn loại tiền bạn muốn nạp",
    "tqdbz": "Vui lòng chọn loại tiền bạn muốn rút",
    "rmbz": "Loại tiền phổ biến",
    "qxz": "Vui lòng chọn",
    "cbwl": "Mạng nạp tiền",
    "cbtips": "Vui lòng đảm bảo bạn đã chọn mạng nạp tiền phù hợp với nền tảng rút tiền, nếu không có thể gây mất mát tài sản.",
    "txfs": "Phương thức rút tiền",
    "lstx": "Rút trên chuỗi",
    "xyb": "Bước tiếp theo",
    "yxzdq": "Đã chọn hiện tại",
    "dbz": "loại tiền",
    "cxxz": "Chọn lại",
    "dzkbz": "Địa chỉ trong kho địa chỉ không đủ, vui lòng liên hệ quản trị viên",
    "qxzcrdbz": "Vui lòng chọn loại tiền cần nạp trước",
    "qxzcbwl": "Vui lòng chọn mạng nạp tiền",
    "qxztqdbz": "Vui lòng chọn loại tiền cần rút trước",
    "cr": "Nạp tiền",
    "tq": "Rút tiền",
    "cbxq": "Chi tiết nạp tiền",
    "txxq": "Chi tiết rút tiền",
    "usdttxjl": "Lịch sử rút {coinName}",
    "qbtxjl": "Tất cả lịch sử rút tiền",
    "zyxx": "Thông tin quan trọng: Bạn chỉ có thể gửi {coinName} đến địa chỉ này, nếu bạn gửi các loại tiền khác, bạn sẽ mất số tiền này.",
    "jzjcr": "Chuyển số tiền vào",
    "smewm": "Quét mã QR hoặc sao chép thông tin dưới đây để gửi đến nền tảng",
    "xcdzcz": "Nạp tiền loại tiền không đúng sẽ làm mất tài sản của bạn",
    "xcdzczss": "Khi nạp XRP, vui lòng sao chép tag, nếu không có thể gây mất tiền.",
    "znhycz": "Hiện tại không hỗ trợ nạp tiền thông minh, nạp tiền đóng gói, nạp tiền thưởng khối",
    "usdtcbdz": "Địa chỉ nạp {coinName}",
    "fzdz": "Sao chép địa chỉ",
    "usdtdz": "Địa chỉ {coinName}",
    "zxcbe": "Số tiền nạp tiền tối thiểu",
    "zytx2": "Thông tin quan trọng: Hãy chắc chắn rằng nền tảng chấp nhận mạng {coinName} bạn đã chọn, nếu không, bạn sẽ mất số tiền này.",
    "kytxwl": "Mạng rút tiền có sẵn của {coinName}",
    "xzwl": "Chọn mạng",
    "dzym": "Địa chỉ {coinName}",
    "srdz": "Nhập địa chỉ hoặc chọn từ danh bạ",
    "jymm": "Mật khẩu giao dịch",
    "qsrjymm": "Vui lòng nhập mật khẩu giao dịch",
    "zxtbe": "Số tiền rút tối thiểu: {minAmount}",
    "ky": "Có sẵn:",
    "zhztbxe": "Giới hạn rút tiền tổng cộng trong tài khoản",
    "gjxyddj": "Dựa trên cấp độ xác minh của bạn, trong 24 giờ, bạn chỉ có thể rút một số tiền hạn chế. Số tiền này sẽ được tính bằng số tiền USD chuyển đổi sang loại tiền bạn chọn.",
    "scbdjd": "Do biến động giá tiền lớn, phí giao dịch cho loại tiền này là phí biến động, dựa trên giá tiền trung bình trong 24 giờ trước, thu phí tương đương với 0.2-0.2 USDT để tăng tốc độ rút tiền",
    "yqdz": "Dự kiến sẽ nhận được",
    "yqdzwf": "Dự kiến sẽ nhận được không thể là số âm",
    "sfrz": "Xác minh danh tính",
    "ggyzm": "Mã xác minh Google",
    "dxyzm": "Mã xác minh tin nhắn",
    "yxyzm": "Mã xác minh email",
    "qsryzm": "Vui lòng nhập mã xác minh",
    "fsyzm": "Gửi mã xác minh",
    "cxfs": "Gửi lại",
    "tj": "Gửi",
    "qxztxwl": "Vui lòng chọn mạng rút tiền",
    "qsrdz": "Vui lòng nhập địa chỉ",
    "qxzdz": "Vui lòng chọn địa chỉ",
    "qxzyzfs": "Vui lòng chọn một phương thức xác minh danh tính",
    "qsrtqsl": "Vui lòng nhập số tiền rút",
    "qwcyz": "Vui lòng hoàn tất xác minh",
    "qqrbdsj": "Vui lòng xác nhận xem có liên kết số điện thoại không",
    "qqrbdyx": "Vui lòng xác nhận xem có liên kết email không",
    "fzcg": "Sao chép thành công!",
    "tbcg": "Rút tiền thành công",
    "usdttxdz": "Địa chỉ rút {coinName}",
    "lmc": "Tên chuỗi:",
    "qtj": "*Vui lòng thêm",
    "dz": "địa chỉ",
    "fei": "Không phải",
    "zjds": "Địa chỉ có thể làm mất tài sản",
    "yzfs": "Phương thức xác minh",
    "yzm": "Mã xác minh",
    "remark": "Ghi chú",
    "qsrremark": "Vui lòng nhập ghi chú",
    "tjdzcg": "Thêm địa chỉ thành công",
    "qxxzyzfs": "Vui lòng chọn phương thức xác minh danh tính trước",
    "qsrtxdz": "Vui lòng nhập địa chỉ rút tiền",
    "stop": 'Tạm ngừng',
  
    // status
    "qr0": "0 xác nhận",
    "qr1": "1 xác nhận",
    "dqr": "Chờ xác nhận",
    "czcg": "Nạp tiền thành công",
    "hzz": "Đang chuyển khoản",
    "ywc": "Đã hoàn thành",
    "sb": "Thất bại",
    "zzcl": "Đang xử lý",
    "ddsh": "Đang chờ xác nhận",
    "txcg": "Rút tiền thành công",
    "cxcg": "Hủy bỏ thành công",
    "ddtx": "Chờ rút tiền",
    "txsb": "Rút tiền thất bại",
    "slsb": "Gửi lên chuỗi thất bại",
    "dfk": "Chờ thanh toán",
    "yfk": "Đã thanh toán",
    "yqx": "Đã hủy",
    "ssz": "Đang khiếu nại",
    "gdfrhz": "Chuyển khoản lợi nhuận theo dõi",
    "hyzh_to_gdzh": "Tài khoản hợp đồng - Tài khoản theo dõi",
    "gdzh_to_hyzh": "Tài khoản theo dõi - Tài khoản hợp đồng",
    "ddcl": "Đang chờ xử lý",
    "cg": "Thành công",
  
    // dialog
    "zchz": "Chuyển khoản tài sản",
    "ljhz": "Chuyển ngay",
    "cong": "Từ",
    "dao": "Đến",
    "qtzh": "Tài khoản khác",
    "qxzbz": "Vui lòng chọn loại tiền",
    "qsrsl": "Vui lòng nhập số lượng",
    "khz": "Có thể chuyển:",
    "ye": "Số dư:",
    "hzcg": "Chuyển khoản thành công",
  
    // h5
    "zcgl": "Tổng quan tài sản",
    "xrzx": "Ưu đãi cho người mới",
    "zzc": "Tổng tài sản",
    "jryk": "Lợi nhuận/khấu hao hôm nay",
    "zgjz": "Gói quà mới người dùng trị giá 3200 USDT đang chờ bạn",
    "zhrj": "Nạp tiền vào tài khoản của bạn",
    "xzrjfs": "Sau khi nạp tiền, bạn có thể mua các loại tiền số, hãy chọn cách nạp tiền phù hợp với bạn",
    "czszhb": "Nạp tiền số",
    "yyydszhb": "Nạp tiền số của bạn từ các nền tảng khác vào tài khoản Biking",
    "czfb": "Nạp tiền bằng tiền mặt",
    "czzhz": "Nạp tiền từ tiền mặt bạn đã có vào tài khoản Biking, hỗ trợ nhiều phương thức thanh toán như thẻ ngân hàng, chuyển khoản và nhiều hình thức khác",
    "maibi": "Mua tiền",
    "tgdsfmb": "Mua tiền số thông qua thẻ ngân hàng, P2P, bên thứ ba và nhiều phương thức khác",
    "yqyl": "Ưu đãi khi mời bạn bè",
    "yqfy": "Mời bạn bè và nhận 20% hoa hồng",
    "cxzzn": "Hướng dẫn cho người mới",
    "czzh": "Tạo một tài khoản Biking",
    "hdxrj": "Nhận 100 USDT khi làm mới",
    "ck": "Nạp tiền",
    "tzndzh": "Đầu tư vào tài khoản của bạn, bắt đầu hành trình của bạn, hỗ trợ nhiều phương thức thanh toán",
    "wcsfrz": "Hoàn thành xác minh danh tính (KYC)",
    "hgzh": "Hoàn thành xác minh danh tính (KYC) và trở thành một tài khoản tuân theo quy định",
    "ksjy": "Bắt đầu giao dịch",
    "tsgd": "Bán, mua hoặc sao chép giao dịch, khám phá thêm",
    "ksndlc": "Bắt đầu hành trình của bạn",
    "kjydjmhb": "Tiền số có thể giao dịch",
    "jmhb": "Giá trị tổng cộng của tiền số là 12284.85 tỷ USD",

    批量导入地址:'Nhập địa chỉ theo lô',
    请输入地址或名称:'Vui lòng nhập địa chỉ hoặc tên',
    地址名称:'tên địa chỉ',
    上传普通地址:'Tải lên địa chỉ bình thường',
    上传成功:'Tải lên thành công',
    一次只能上传一个文件哦:'Mỗi lần chỉ có thể tải lên một tệp',
    文件大小不得超过10M:'Kích thước tệp không được vượt quá 10M',
    请先选择要上传的文件:'Vui lòng chọn tệp để tải lên trước',
    只能上传后缀是:'Chỉ những tệp có hậu tố .xlsx hoặc .xls hoặc .csv mới có thể được tải lên',
    将文件拖到此处:'Kéo tệp vào đây hoặc',
    点击上传:'Bấm để tải lên',
    最大1MB:'Tệp CSV, XLS, XLSX lên tới 1 MB',
    编号:'số seri',
    所属网络:'Thuộc mạng lưới',
    地址簿:'sổ địa chỉ',
    新增地址:'Thêm địa chỉ',
    提币地址一次不超过100个:'Số lượng địa chỉ rút tiền cùng một lúc không quá 100',
    添加地址:'Thêm địa chỉ',
    保存地址:'lưu địa chỉ',
    下载模板:'Tải xuống mẫu',
    批量提现:'Rút tiền hàng loạt',
    请输入Memo:'Vui lòng nhập bản ghi nhớ',
    请输入地址名称:'Vui lòng nhập tên địa chỉ',
        zengjin: "món quà",
    lc: "quản lý tài chính",
    mb: "mua xu",
    lsjl: "Lịch sử",
    zclb: "Danh sách tài sản",
    shaixuan: "bộ lọc",
    您可以通过:'Bạn có thể tải lên tối đa 20 địa chỉ phổ biến thông qua tệp định dạng CSV, XLS hoặc XLSX (tối đa 1 MB). Tiêu đề của mỗi cột phải nhất quán với mẫu, nếu không quá trình tải lên sẽ không thành công.'
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/property/vi.js